import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-50f6037e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " Innovation Booster "), /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, [/*#__PURE__*/_createTextVNode(" The innovation booster is designed to provide an initial push for your product's visibility. Adjust these settings to optimize your product's market introduction."), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" You can choose to turn it off (set to x1) or customize the boost intensity and duration. ")])], -1));
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subheader"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " Maximum Bid Boost Level "), /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, " Adjust the peak bid multiplier for your newly released products. As the products progress through their launch phase, this boost will systematically decrease until it reaches a neutral bid. ")], -1));
const _hoisted_4 = {
  class: "slider-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_slider = _resolveComponent("app-slider");
  const _component_app_card_custom = _resolveComponent("app-card-custom");
  return _openBlock(), _createBlock(_component_app_card_custom, {
    "no-padding": ""
  }, {
    default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_app_slider, {
      modelValue: $options.localBoost,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.localBoost = $event),
      options: $data.levels
    }, null, 8, ["modelValue", "options"])])])]),
    _: 1
  });
}